var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopHacks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49992 36.6667V28.3333M7.49992 11.6667V3.33334M3.33325 7.50001H11.6666M3.33325 32.5H11.6666M21.6666 5.00001L18.7763 12.5148C18.3063 13.7368 18.0713 14.3479 17.7058 14.8618C17.3819 15.3173 16.9839 15.7153 16.5284 16.0392C16.0144 16.4047 15.4034 16.6397 14.1814 17.1097L6.66659 20L14.1814 22.8903C15.4034 23.3603 16.0144 23.5953 16.5284 23.9608C16.9839 24.2847 17.3819 24.6827 17.7058 25.1382C18.0713 25.6522 18.3063 26.2632 18.7763 27.4852L21.6666 35L24.5569 27.4852C25.0269 26.2632 25.2619 25.6522 25.6274 25.1382C25.9513 24.6827 26.3493 24.2847 26.8048 23.9608C27.3187 23.5953 27.9298 23.3603 29.1518 22.8903L36.6666 20L29.1518 17.1097C27.9298 16.6397 27.3187 16.4047 26.8048 16.0392C26.3493 15.7153 25.9513 15.3173 25.6274 14.8618C25.2619 14.3479 25.0269 13.7368 24.5569 12.5148L21.6666 5.00001Z",
    stroke: "url(#paint0_linear_1693_5088)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1693_5088",
    x1: 36.9993,
    y1: 3.00034,
    x2: 2.99927,
    y2: 37.5003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#068AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A332EE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopHacks);
export default __webpack_public_path__ + "static/media/top_hacks.834322905de90c44f9496ccf9b15c635.svg";
export { ForwardRef as ReactComponent };